var createErrorSlice = function (set, get, _api) { return ({
    error: "",
    setError: function (err) {
        set(function () { return ({ error: err }); });
    },
}); };
export default createErrorSlice;
